export default "__VITE_ASSET__DiFD5a1X__"